import { ReactElement, useState } from 'react';
import { useMessage } from '@messageformat/react';
import { SegmentedButton } from '@op/opds.opux';
import FeedbackMessage from './FeedbackMessage';
import QuestionTile from './QuestionTile';
import useA11yRadioOptionComponents from '../hooks/useA11yRadioOptionComponents';
import styles from './SegmentedButtonQuestionTile.module.scss';

interface Props {
  courseNumber: number;
  taskNumber: number;
  number: string;
  correctAnswer: string;
  options: string[];
  onAnswered: (isCorrect: boolean) => void;
  infoText?: string;
}

const SegmentedButtonQuestionTile = ({
  courseNumber,
  taskNumber,
  number,
  correctAnswer,
  options,
  onAnswered,
  infoText,
}: Props): ReactElement => {
  const [value, setValue] = useState('');

  const handleChange = (val: string): void => {
    setValue(val);
    onAnswered(val === correctAnswer);
  };

  const question = useMessage(
    `course${courseNumber}.task${taskNumber}.question${number}.text`,
  );

  const radioOptionComponents = useA11yRadioOptionComponents({
    options: options.map((option) => ({ value: option, text: option })),
    onChange: handleChange,
    className: styles.input,
  });

  const labelledbyId = `course${courseNumber}-task${taskNumber}-question${number}-label`;
  const isCorrect = value === correctAnswer;
  return (
    <QuestionTile number={number} question={question}>
      <p id={labelledbyId} style={{ display: 'none' }}>
        {`${number}. ${question}`}
      </p>
      <SegmentedButton aria-labelledby={labelledbyId} value={value} segmentMinWidth="50%">
        {radioOptionComponents}
      </SegmentedButton>
      <FeedbackMessage
        hasAnswered={value !== ''}
        isCorrect={isCorrect}
        infoText={isCorrect ? infoText : undefined}
      />
    </QuestionTile>
  );
};

export default SegmentedButtonQuestionTile;
